import { GET_MATERIAL } from "./type";

const initalState = {
  materialData: [],
};

const materialDeliveryReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MATERIAL:
      return {
        ...state,
        materialData: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default materialDeliveryReducer;
